import { createContext, useContext, useState, useEffect, ReactNode } from 'react'

interface SignInModalContextType {
  isOpen: boolean
  openSignInModal: () => void
  closeSignInModal: () => void
}

const SignInModalContext = createContext<SignInModalContextType | undefined>(undefined)

export function SignInModalProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false)

  // ESC key handler
  useEffect(() => {
    if (!isOpen) return

    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        setIsOpen(false)
      }
    }
    window.addEventListener('keydown', handleEscape)
    return () => window.removeEventListener('keydown', handleEscape)
  }, [isOpen])

  return (
    <SignInModalContext.Provider
      value={{
        isOpen,
        openSignInModal: () => setIsOpen(true),
        closeSignInModal: () => setIsOpen(false),
      }}
    >
      {children}
    </SignInModalContext.Provider>
  )
}

export function useSignInModal(): SignInModalContextType {
  const context = useContext(SignInModalContext)
  if (!context) {
    throw new Error('useSignInModal must be used within SignInModalProvider')
  }
  return context
}
